import React, { useEffect, useState } from 'react';
import LateralPanel from '../../../../../muiComponents/LateralPanel';
import IconButton from '../../../../../muiComponents/IconButton';
import useTranslate from '../../../../../customHooks/useTranslate';
import { CompetitorAnalysisComparison } from '../../../types/competitors';
import CompetitorViewer from './competitorViewer/CompetitorViewer';
import { useZitoneoHotelPresentation } from '../../../contexts/ZitoneoContentContext';
import { commonIcons } from '../../../../../utils/commonVariables/commonIcons';

interface CompetitorViewerPanelProps {
    open: boolean;
    onClose: () => void;
    analysis: CompetitorAnalysisComparison | null;
}

const CompetitorViewerPanel = ({
    open,
    onClose,
    analysis,
}: CompetitorViewerPanelProps) => {
    const translate = useTranslate();
    const { hotel } = useZitoneoHotelPresentation();
    const [isFullScreen, setIsFullScreen] = useState(false);

    useEffect(() => {
        if (!open) {
            setIsFullScreen(false);
        }
    }, [open]);

    if (!open || !analysis) {
        return null;
    }

    return (
        <LateralPanel
            open={open}
            onClose={onClose}
            className={` flex-column gap-20 ${
                isFullScreen ? '--full-width' : '--xl-width'
            }`}
            aria-labelledby='competitor-viewer-panel-title'
        >
            <header className='flex flex-between flex-align-center'>
                <h2
                    id='competitor-viewer-panel-title'
                    className='lateral-panel__title'
                >
                    {translate('competitor_analysis')}
                </h2>
                <div className='flex gap-10'>
                    <IconButton
                        iconName={
                            isFullScreen
                                ? commonIcons.EXIT_FULL_SCREEN
                                : commonIcons.FULL_SCREEN
                        }
                        onClick={() => setIsFullScreen(!isFullScreen)}
                        aria-label={translate(
                            isFullScreen ? 'exit_full_screen' : 'full_screen'
                        )}
                    />
                    <IconButton
                        iconName={commonIcons.CLOSE}
                        onClick={onClose}
                        aria-label={translate('close')}
                    />
                </div>
            </header>

            <CompetitorViewer
                competitorName={
                    analysis.competitorName || analysis.competitor.name
                }
                data={analysis}
                ownName={hotel.name}
            />
        </LateralPanel>
    );
};

export default CompetitorViewerPanel;
